import React, { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getUserId, getAllUsers } from "../data/userService";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { LoadingSetting } from "../componets/LoadingSetting";

interface ProtectedRouteProps {
  element: React.ReactElement;
}

const ProtectedRouteAdmin: React.FC<ProtectedRouteProps> = ({ element }) => {
  const privilegedLevels = ["admin", "dev"];
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const auth = getAuth();
  const location = useLocation();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setIsAuthenticated(true);
        try {
          const allUsers = await getAllUsers();
          const currentUserId = getUserId();
          if (currentUserId && allUsers) {
            const currentUser = allUsers[currentUserId];
            if (privilegedLevels.includes(currentUser.level)) {
              setIsAuthorized(true);
            } else {
              setIsAuthorized(false);
            }
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
          setIsAuthorized(false);
        }
      } else {
        setIsAuthenticated(false);
        setIsAuthorized(false);
      }
      setIsLoading(false);
    });

    return () => unsubscribe();
  }, [auth]);

  if (isLoading) {
    return <LoadingSetting />;
  }

  if (isAuthenticated === null || isAuthorized === null) {
    return <LoadingSetting />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  return isAuthorized ? (
    element
  ) : (
    <Navigate to="/lista" state={{ from: location }} />
  );
};

export default ProtectedRouteAdmin;
